import React from 'react';
import { Route } from 'react-router-dom';
import { HelpPage } from './HelpPage';

export const routes = [<Route key="0" path="/help" component={HelpPage} />];

export const navigation = [{ name: 'Hjälp', link: '/help', icon: 'Help' }];
